import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { apiClient } from '@/lib/api-client';
import { queryKeys } from '@/lib/query-keys';
import type { AdminFailuresResponse } from '@/types/api';

export function useAdminFailuresQuery(
  enabled: boolean,
): UseQueryResult<AdminFailuresResponse, Error> {
  return useQuery<AdminFailuresResponse, Error>({
    queryKey: queryKeys.adminFailures(),
    queryFn: ({ signal }) => apiClient.getAdminFailures(signal),
    enabled,
    // Queue depths move; keep them reasonably fresh while the page is open.
    staleTime: 15_000,
    refetchInterval: 60_000,
  });
}
